import { render, staticRenderFns } from "./DeviceCurtain.vue?vue&type=template&id=8a52b89c&scoped=true&"
import script from "./DeviceCurtain.vue?vue&type=script&lang=js&"
export * from "./DeviceCurtain.vue?vue&type=script&lang=js&"
import style0 from "./DeviceCurtain.vue?vue&type=style&index=0&id=8a52b89c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a52b89c",
  null
  
)

export default component.exports